/** The visitor pages' route patterns; `:key` is the client key, `encodeURIComponent`'d (it may hold slashes). */
export const VISITOR_ROUTE = '/team/visitors/:key';
export const PASS_ROUTE = '/team/visitors/:key/pass';
